export default {
  'finance.instructionsLanguage': '语言',
  'finance.operationTime': '操作时间',
  'finance.operation': '操作',
  'finance.accountId': '账号ID',
  'finance.withdrawal': '出款',
  'finance.deposit': '入款',
  'finance.amount': '金额',
  'finance.enterAmount': '请输入金额',
  'finance.amountMustBeGreaterThanZero': '金额必须大于 0',
  'finance.enterAccountToQuery': '输入账号查询之后才能进行出入款',
  'finance.hint': '提示',
  'finance.rejectWithdrawalApplication': '拒绝出款申请?',
  'finance.applicationRejected': '已拒绝申请',
  'finance.manualWithdrawalDeductBalance':
    '选择手动出款，会直接扣除会员余额，确定为出款，是否继续？',
  'finance.manualWithdrawalExecuted': '已执行手动出款',
  'finance.selectWithdrawalChannel': '选择出款渠道',
  'finance.withdrawalChannel': '出款渠道',
  'finance.selectChannelFirst': '请先选择一个渠道',
  'finance.autoWithdrawalExecuted': '已执行自动出款',
  'finance.date': '日期',
  'finance.orderNumber': '订单号',
  'finance.phoneAccountId': '手机号 / 账号ID',
  'finance.currency': '币种',
  'finance.totalWithdrawal': '总出款',
  'finance.walletName': '钱包名称',
  'finance.accountNumber': '户口账号',
  'finance.withdrawalAmount': '出款金额',
  'finance.withdrawalStatus': '出款状态',
  'finance.time': '时间',
  'finance.internalRemark': '内部备注',
  'finance.rejectReason': '拒绝原因',
  'finance.rejectReasonMemberVisible': '拒绝原因:(会员可读此信息)',
  'finance.withdrawing': '出款中',
  'finance.applying': '申请中',
  'finance.withdrawn': '已出款',
  'finance.manualWithdrawn': '手动出款',
  'finance.returned': '已退回',
  'finance.applicationPending': '申请中',
  'finance.withdrawalInProgress': '出款中',
  'finance.withdrawalCompleted': '已出款',
  'finance.withdrawalReturned': '已退回',
  'finance.exceptionOrder': '异常订单',
  'finance.manualWithdrawal': '手动出款',
  'finance.autoWithdrawal': '自动出款',
  'finance.applicationTime': '申请时间：',
  'finance.settlementTime': '结算时间：',
  'finance.lock': '锁定',
  'finance.review': '审核',
  'finance.beingReviewedBy': '已被 {user} 审核',
  'finance.unlock': '解锁',
  'finance.activate': '激活',
  'finance.withdrawnCompleted': '已出款',
  'finance.confirmThirdPartyStatus': '请前往三方确认该订单出款状态，否则可能会重复出款！',
  'finance.fuzzyQuery': '模糊查询',
  'finance.reset': '重置',
  'finance.withdrawalReview': '出款审核',
  'finance.confirmLock': '确定锁定吗？',
  'finance.confirmUnlock': '确定解锁吗？',
  'finance.confirmActivate': '确定激活吗？',
  'finance.balance': '余额',
  'finance.enterWithdrawalAmount': '请输入出款金额',
  'finance.enterMark': '请输入备注',
  'finance.whetherUser': '是否对该用户',
  'finance.withdrawalRequestDetails': '出款申请明细',
  'finance.memberInformation': '会员信息',
  'finance.previousWithdrawalTime': '前一出款时间',
  'finance.historicalTotalWithdrawals': '历史总出款 {count} 次, 共 {currency}{amount}',
  'finance.memberRegistrationTime': '会员注册时间',
  'finance.todayTotalWithdrawals': '今日总出款 {count} 次, 共 {amount}',
  'finance.orderInformation': '订单信息',
  'finance.payoutChannel': '代付渠道',
  'finance.withdrawalInformation': '出款信息',
  'finance.copiedToClipboard': '已复制到剪贴板',
  'finance.copyFailed': '复制失败',
  'finance.copyEmpty': '内容为空，无法复制',

  'payoutChannel.title': '出款渠道',
  'payoutChannel.withdrawChannel': '出款渠道',
  'payoutChannel.withdrawType': '出款类型',
  'payoutChannel.channelStatus': '渠道状态',
  'payoutChannel.walletName': '钱包名称',
  'payoutChannel.operation': '操作',
  'payoutChannel.merchantName': '商户名称',
  'payoutChannel.merchantCode': '商户号',
  'payoutChannel.deleteConfirm': '是否删除?',
  'payoutChannel.operationSuccessful': '操作成功',

  // CreateTemplateForm - Title
  'payoutChannel.form.title.add': '添加出款渠道',
  'payoutChannel.form.title.edit': '编辑出款渠道',

  // CreateTemplateForm - Labels
  'payoutChannel.form.labels.withdrawChannel': '出款渠道',
  'payoutChannel.form.labels.merchantName': '商户名称',
  'payoutChannel.form.labels.walletName': '钱包名称',
  'payoutChannel.form.labels.merchantCode': '商户号',
  'payoutChannel.form.labels.secretKey': '密钥',
  'payoutChannel.form.labels.publicKey': '公钥',
  'payoutChannel.form.labels.privateKey': '私钥',
  'payoutChannel.form.labels.payUrl': '代付下单地址',
  'payoutChannel.form.labels.withdrawLimit': '出款限额',
  'payoutChannel.form.labels.minAmount': '最小金额',
  'payoutChannel.form.labels.maxAmount': '最大金额',

  // CreateTemplateForm - Placeholders
  'payoutChannel.form.placeholders.selectWithdrawChannel': '请选择出款渠道',
  'payoutChannel.form.placeholders.enterMerchantName': '请输入商户名称',
  'payoutChannel.form.placeholders.selectWalletName': '请选择钱包名称',
  'payoutChannel.form.placeholders.enterMerchantCode': '请输入商户号',
  'payoutChannel.form.placeholders.enterSecretKey': '密钥(选填)',
  'payoutChannel.form.placeholders.enterPublicKey': '公钥(选填)',
  'payoutChannel.form.placeholders.enterPrivateKey': '私钥(选填)',
  'payoutChannel.form.placeholders.enterPayUrl': '代付下单地址',
  'payoutChannel.form.placeholders.enterSort': '排序',
  'payoutChannel.form.placeholders.enterMinAmount': '最小金额',
  'payoutChannel.form.placeholders.enterMaxAmount': '最大金额',
  'payoutChannel.form.placeholders.enterRemark': '备注',

  // CreateTemplateForm - Validation
  'payoutChannel.form.validation.withdrawChannelRequired': '请选择出款渠道',
  'payoutChannel.form.validation.merchantNameRequired': '请输入商户名称',
  'payoutChannel.form.validation.walletNameRequired': '请选择钱包名称',
  'payoutChannel.form.validation.merchantCodeRequired': '请输入商户号',
  'payoutChannel.form.validation.sortRequired': '排序不能为空',
  'payoutChannel.form.validation.minAmountRequired': '最小金额不能为空',
  'payoutChannel.form.validation.maxAmountRequired': '最大金额不能为空',
  'payoutChannel.form.validation.maxAmountMustBeGreaterThanMinAmount':
    '最大金额必须大于或等于最小金额',

  // CreateTemplateForm - Messages
  'payoutChannel.form.messages.to': '至',
  'payoutChannel.form.messages.optional': '(选填)',

  'finance.confirmWithdraw1': '请前往三方确认该订单出款状态,否则可能会重复出款!',
  'finance.confirmWithdraw2': '确定为未出款,请将订单点【激活】按钮改为“未出款"状态',
  'finance.confirmWithdraw3': '确定为已出款,请将订单点【已出款】按钮改为“已出款"状态',

  'finance.rejectReason.readable': '会员可读取拒绝原因',

  'finance.rejectReasonNotAllowed': '当填入拒绝原因后，只有拒绝按钮可以通过',

  // 出款限制
  'finance.update': '更新',
  'finance.withdrawLimitTitle': '出款限制',
  'finance.withdrawLimitInviteTitle': '邀请人数（增量）',
  'finance.withdrawLimitInviteDesc': '累计成功邀请人数：本次发起提现时—上次发起提现时≥：',
  'finance.withdrawLimitCountDesc': '人数：提现时，要求邀请人数的增量。',
  'finance.withdrawLimitRange': '请输入 0~999 的整数',
  'finance.withdrawLimitInviteRequired': '请输入累计成功邀请人数',
  'finance.withdrawLimitAmount': '金额',
  'finance.withdrawLimitCount': '人数',
  'finance.withdrawLimitAmountPlaceholder': '请输入金额',
  'finance.withdrawLimitCountPlaceholder': '请输入人数',
  'finance.withdrawLimitAmountRequired': '请输入金额',
  'finance.withdrawLimitAmountRange': '请输入 1~99999 的整数',
  'finance.withdrawLimitCountRequired': '请输入人数',
  'finance.withdrawLimitAdd': '添加',
  'finance.withdrawLimitFreeRegisterPrefix': '不限制：注册',
  'finance.withdrawLimitFreeRegisterSuffix': '小时内',
  'finance.withdrawLimitFreeRegisterRequired': '请输入小时数',
  'finance.withdrawLimitFreqEach': '每次',
  'finance.withdrawLimitFreqDaily': '每天',
  'finance.withdrawLimitRestrictTitle': '提现限制',
  'finance.withdrawLimitPwaOnly': '只能通过PWA发起提现',
  'finance.withdrawLimitKycRequired': '完成KYC才能发起提现',
  'finance.withdrawLimitPeerCashout': '引流至TOSPORT完成提现',
  'finance.withdrawLimitPeerUrlMovedTip':
    '提现、门票的引流注册地址已改为在「推广渠道」中按渠道配置，此处开关只决定功能是否开启',
  'finance.withdrawLimitPeerTicketRedirect': '门票不足/为0时，参与比赛时提醒跳转',
  'finance.withdrawLimitPeerRemindPrefix': '注册第',
  'finance.withdrawLimitPeerRemindSuffix':
    '天开始，门票为0时，打开时提醒跳转 TOSPORT，每天提醒一次',
  'finance.withdrawLimitPeerRemindEdit': '修改',
  'finance.withdrawLimitPeerRemindDayRange': '打开提醒天数须为 0 到 99 的整数',
};
